export const compareArrays = (original: number[], selected: number[], strict = false): boolean => {
  if (original.length !== selected.length) {
    return false;
  }

  if (strict) {
    for (let i = 0; i < original.length; i++) {
      if (original[i] !== selected[i]) {
        return false;
      }
    }
    return true;
  }

  const sortedOriginal = [...original].sort((a, b) => a - b);
  const sortedSelected = [...selected].sort((a, b) => a - b);

  for (let i = 0; i < sortedOriginal.length; i++) {
    if (sortedOriginal[i] !== sortedSelected[i]) {
      return false;
    }
  }
  return true;
};

export const isUniqueArray = (array: string[]): boolean => {
  const filteredArray = new Set();
  array.map((item: string) => filteredArray.add(item.toLowerCase()));

  return filteredArray.size === array.length;
};

export const sortArrayAlphabetically = (arr: any[], field: string | null = null): any[] =>
  // toSorted() (ES2023) would be the natural fit here, but it isn't polyfilled anywhere in this
  // app's build (CRA doesn't auto-polyfill runtime built-ins, and nothing here imports core-js), so
  // it throws on any browser without native support. Spread-then-sort gets the same non-mutating
  // result without that risk.
  [...arr].sort((a, b) => {
    const left = field ? a?.[field] : a;
    const right = field ? b?.[field] : b;
    if (left < right) {
      return -1;
    }
    if (left > right) {
      return 1;
    }
    return 0;
  });

/** Returns a new array with the element at `index` removed, rather than mutating `array` (unlike `Array.prototype.splice`). */
export const removeAtIndex = <T>(array: T[], index: number): T[] => array.filter((_, i) => i !== index);

/** Returns a new array with the element at `index` replaced by `item`, rather than mutating `array` (unlike `Array.prototype.splice`). */
export const replaceAtIndex = <T>(array: T[], index: number, item: T): T[] =>
  array.map((existing, i) => (i === index ? item : existing));

/** Returns a new array with `item` inserted before `index`, rather than mutating `array` (unlike `Array.prototype.splice`). */
export const insertAtIndex = <T>(array: T[], index: number, item: T): T[] => [
  ...array.slice(0, index),
  item,
  ...array.slice(index)
];

export const sortArrayByName = (arr: any[]) => sortArrayAlphabetically(arr, 'name');

export const sleep = (ms: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

export const handleHttpsInput = (input: string): string => {
  const trimmedValue = input.trim();
  const expectedChars = ['h', 't', 't', 'p', 's', ':', '/', '/'];
  const length = trimmedValue.length > expectedChars.length ? expectedChars.length : trimmedValue.length;
  for (let i = 0; i < length; i++) {
    if (trimmedValue[i] !== expectedChars[i]) {
      return `https://${trimmedValue}`;
    }
  }

  return input;
};

export const isValidWebUrl = (value?: string | null): boolean => {
  if (!value) return false;
  try {
    const url = new URL(value.trim());
    return (url.protocol === 'https:' || url.protocol === 'http:') && url.hostname.includes('.');
  } catch {
    return false;
  }
};
